'use client'

import styled from 'styled-components'

import theme from '@/src/config/theme'
import {media} from '@/src/config/theme'

export const CatalogFiltersMobileBtn = styled.button`
  @media ${media.md} {
    display: none;
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  justify-content: flex-start;

  @media ${media.lg} {
    justify-content: space-between;
  }
`

export const ContainerCentered = styled.div`
  display: flex;
  justify-content: center;
`

export const Container = styled.div`
  width: 100%;
  max-width: ${theme.sizes.container}px;
  padding-bottom: 2rem;
`

export const CatalogOptions = styled.div`
  padding-top: 28px;
`

export const DesktopPagination = styled.div`
  width: 100%;

  &.ant-pagination {
    justify-content: space-around;
  }

  @media ${media.lg} {
    width: unset;
  }
`

export const PaginationOptions = styled.div`
  width: 100%;
  justify-content: center;

  @media ${media.lg} {
    width: unset;
  }
`
